// ** React Imports
import { useEffect, useState } from 'react'

import { useLocation, useNavigate } from 'react-router-dom'

// ** Context Imports
import { AbilityContext } from 'src/layouts/components/acl/Can'

// ** Config Import
import authConfig from 'src/configs/auth'

// ** Component Import
import BlankLayout from 'src/@core/layouts/BlankLayout'

// ** Hooks
import { useAuth } from 'src/hooks/useAuth'

const AclGuard = props => {
  // ** Props
  const { aclAbilities, children, guestGuard } = props
  const [ability] = useState(undefined)

  // ** Hooks
  const auth = useAuth()
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(
    () => {
      if (
        !(
          guestGuard ||
          location.pathname === '/404' ||
          location.pathname === '/500' ||
          location.pathname === '/landing-page' ||
          location.pathname === '/subscription-page' ||
          location.pathname === '/how-it-works' ||
          location.pathname === '/newly-added-servicepage' ||
          location.pathname === '/newly-registered-agents' ||
          location.pathname === '/international-routes-page' ||
          location.pathname === '/domestic-routes-page' ||
          location.pathname === '/domestic-agents-page' ||
          location.pathname === '/international-agents-page' ||
          location.pathname === '/worldwide-directory' ||
          location.pathname.includes('/country-directory-page') ||
          location.pathname.includes('/company-details') ||
          location.pathname.includes('/storefront') ||
          location.pathname === '/oujat-digital-wallet-page' ||
          location.pathname === '/policies-rules-page' ||
          location.pathname === '/privacy-policy-page' ||
          location.pathname === '/terms-of-use-page' ||
          location.pathname === '/legal-notice-page' ||
          location.pathname === '/service-listing-policy-page' ||
          location.pathname === '/aboutus' ||
          location.pathname === '/contact-us' ||
          location.pathname === '/securedpayments' ||
          location.pathname === '/agentcategories' ||
          location.pathname === '/customerstype' ||
          location.pathname === '/oujatreads' ||
          location.pathname.includes('/popularblogs') ||
          location.pathname === '/career' ||
          location.pathname === '/apply-jobs' ||
          location.pathname === '/jobs-details' ||
          location.pathname === '/help-center' ||
          location.pathname.includes('/help-center/sub-help') ||
          location.pathname === 'help-center/sub-help' ||
          location.pathname === '/allServices' ||
          location.pathname === '/categories/internationalTransport' ||
          location.pathname === '/categories/domesticTransportcitywide' ||
          location.pathname === '/categories/domesticTransportcitytocity' ||
          location.pathname === '/categories/customsServices' ||
          location.pathname === '/categories/warehouseServices' ||
          location.pathname === '/categories/portAgencyServices' ||
          location.pathname === '/categories/brokerageServices' ||
          location.pathname === '/compare-services' ||
          location.pathname.includes('/with-oujat-protection') ||
          location.pathname.includes('/without-oujat-protection') ||
          location.pathname.includes('/similar-services-details')
        )
      ) {
        const currentPath = location.pathname + location.search + location.hash
        if (auth.user === null && !window.localStorage.getItem(authConfig.storageUserDataKeyName)) {
          if (currentPath !== '/') {
            navigate(`/login?redirect=${currentPath}`)
          } else {
            navigate('/landing-page')
          }
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  // If guestGuard is true and user is not logged in or its an error page, render the page without checking access
  if (
    guestGuard ||
    location.pathname === '/404' ||
    location.pathname === '/500' ||
    location.pathname === '/landing-page' ||
    location.pathname === '/subscription-page' ||
    location.pathname === '/how-it-works' ||
    location.pathname === '/newly-added-servicepage' ||
    location.pathname === '/newly-registered-agents' ||
    location.pathname === '/international-routes-page' ||
    location.pathname === '/domestic-routes-page' ||
    location.pathname === '/domestic-agents-page' ||
    location.pathname === '/international-agents-page' ||
    location.pathname === '/worldwide-directory' ||
    location.pathname.includes('/country-directory-page') ||
    location.pathname.includes('/company-details') ||
    location.pathname.includes('/storefront') ||
    location.pathname === '/oujat-digital-wallet-page' ||
    location.pathname === '/policies-rules-page' ||
    location.pathname === '/privacy-policy-page' ||
    location.pathname === '/terms-of-use-page' ||
    location.pathname === '/legal-notice-page' ||
    location.pathname === '/service-listing-policy-page' ||
    location.pathname === '/aboutus' ||
    location.pathname === '/contact-us' ||
    location.pathname === '/securedpayments' ||
    location.pathname === '/agentcategories' ||
    location.pathname === '/customerstype' ||
    location.pathname === '/oujatreads' ||
    location.pathname.includes('/popularblogs') ||
    location.pathname === '/career' ||
    location.pathname === '/apply-jobs' ||
    location.pathname === '/jobs-details' ||
    location.pathname === '/help-center' ||
    location.pathname === '/help-center/sub-help' ||
    location.pathname.includes('/help-center/sub-help') ||
    location.pathname === '/allServices' ||
    location.pathname === '/categories/internationalTransport' ||
    location.pathname === '/categories/domesticTransportcitywide' ||
    location.pathname === '/categories/domesticTransportcitytocity' ||
    location.pathname === '/categories/customsServices' ||
    location.pathname === '/categories/warehouseServices' ||
    location.pathname === '/categories/portAgencyServices' ||
    location.pathname === '/categories/brokerageServices' ||
    location.pathname === '/compare-services' ||
    location.pathname.includes('/with-oujat-protection') ||
    location.pathname.includes('/without-oujat-protection') ||
    location.pathname.includes('/similar-services-details')
  ) {
    return <>{children}</>
  }

  // User is logged in, build ability for the user based on his role
  // if (auth.user && auth.user && !ability) {
  //   setAbility(buildAbilityFor(auth.user.role, aclAbilities.subject))
  // }

  // Check the access of current user and render pages
  if (ability && ability.can(aclAbilities.action, aclAbilities.subject)) {
    return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>
  }

  // Render Not Authorized component if the current user has limited access
  return <BlankLayout>{/* <NotAuthorized /> */}</BlankLayout>
}

export default AclGuard
